import type { MetricStat } from '@/schemas/commons';

import { styles } from './Dashboard.styles';

export const sparkPoints = (values: number[]): string => {
	if (values.length === 0) return '';
	const max = Math.max(...values);
	const min = Math.min(...values);
	const range = max - min || 1;

	return values
		.map((value, index) => {
			const x = (index / (values.length - 1)) * 60;
			const y = 22 - ((value - min) / range) * 18;

			return `${x.toFixed(1)},${y.toFixed(1)}`;
		})
		.join(' ');
};

export const deltaClass = (stat: MetricStat): string => {
	if (stat.deltaDirection === 'up') return styles.deltaUp;
	if (stat.deltaDirection === 'down') return styles.deltaDown;
	return styles.deltaFlat;
};
